import { post, get } from 'Api';


/**
 * Submit a rating score to an order feedback
 * @param  {Object}  feedback
 * @return {Promise.string}
 */
const submitRating = async (feedback) => {
  let text;
  try {
    const { response, data } = await post([], '/user/feedback/submit-feedback', feedback);
    if (response.ok) text = data.rating;
  } catch (ex) { /* */ }
  return text;
};

/**
 * Submit review text to an order feedback
 * @param  {[type]}  feedback
 * @return {Promise.Number}
 */
const submitText = async (feedback) => {
  let rating;
  try {
    const { response, data } = await post([], '/user/feedback/submit-feedback', feedback);
    if (response.ok) rating = data.text;
  } catch (ex) { /* */ }
  return rating;
};

/**
 * Retrieve feedback for a given order and product
 * @return {Promise} [description]
 */
const getFeedback = async (productId) => {
  let feedback = null;
  try {
    const { response, data } = await get([], `/user/feedback/get-feedback/${productId}`);
    if (response.ok) feedback = data;
  } catch (ex) { /* */ }
  return feedback;
};

export {
  submitRating,
  submitText,
  getFeedback,
};
